<div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
    <div>
        <div class="mb-5 sm:mb-8">
            <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                Sign Up
            </h1>
            <p class="text-md text-gray-500 dark:text-gray-400">
                Join us today! Please provide your information to sign up
            </p>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSignUp()" class="space-y-6">

            <!-- User Name -->
            <div>
                <app-lable>User Name <span class="text-error-500">*</span></app-lable>
                <app-input-field type="text" formControlName="uname" name="handle" autocomplete="nickname"
                    placeholder="Please enter user name"
                    [error]="!!fieldError('uname')" [hint]="fieldError('uname')" />
            </div>

            <!-- Shop Name -->
            <div>
                <app-lable>Shop Name <span class="text-error-500">*</span></app-lable>
                <app-input-field type="text" formControlName="fname" placeholder="Please enter your shop name"
                    [error]="!!fieldError('fname')" [hint]="fieldError('fname')" />
            </div>

            <!-- Email -->
            <div>
                <app-lable>Email <span class="text-error-500">*</span></app-lable>
                <app-input-field type="email" name="email" autocomplete="username"
                    placeholder="info@gmail.com" formControlName="email"
                    [error]="!!fieldError('email')" [hint]="fieldError('email')" />
            </div>

            <!-- Password -->
            <div>
                <app-lable>Password <span class="text-error-500">*</span></app-lable>
                <div class="relative">
                    <app-input-field [type]="showPassword ? 'text' : 'password'" placeholder="Please enter password"
                        formControlName="password" [error]="!!fieldError('password')" [hint]="fieldError('password')"
                        [blockSpaces]="true" />
                    <span (click)="togglePasswordVisibility()"
                        class="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-[22px]">
                        @if (showPassword) {
                        <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="fill-gray-500 dark:fill-gray-400 size-5">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M10.0002 13.8619C7.23361 13.8619 4.86803 12.1372 3.92328 9.70241C4.86804 7.26761 7.23361 5.54297 10.0002 5.54297C12.7667 5.54297 15.1323 7.26762 16.0771 9.70243C15.1323 12.1372 12.7667 13.8619 10.0002 13.8619ZM10.0002 4.04297C6.48191 4.04297 3.49489 6.30917 2.4155 9.4593C2.3615 9.61687 2.3615 9.78794 2.41549 9.94552C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C13.5184 15.3619 16.5055 13.0957 17.5849 9.94555C17.6389 9.78797 17.6389 9.6169 17.5849 9.45932C16.5055 6.30919 13.5184 4.04297 10.0002 4.04297ZM9.99151 7.84413C8.96527 7.84413 8.13333 8.67606 8.13333 9.70231C8.13333 10.7286 8.96527 11.5605 9.99151 11.5605H10.0064C11.0326 11.5605 11.8646 10.7286 11.8646 9.70231C11.8646 8.67606 11.0326 7.84413 10.0064 7.84413H9.99151Z" />
                        </svg>
                        } @else {
                        <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="fill-gray-500 dark:fill-gray-400 size-5">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M4.63803 3.57709C4.34513 3.2842 3.87026 3.2842 3.57737 3.57709C3.28447 3.86999 3.28447 4.34486 3.57737 4.63775L4.85323 5.91362C3.74609 6.84199 2.89363 8.06395 2.4155 9.45936C2.3615 9.61694 2.3615 9.78801 2.41549 9.94558C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C11.255 15.3619 12.4422 15.0737 13.4994 14.5598L15.3625 16.4229C15.6554 16.7158 16.1302 16.7158 16.4231 16.4229C16.716 16.13 16.716 15.6551 16.4231 15.3622L4.63803 3.57709ZM12.3608 13.4212L10.4475 11.5079C10.3061 11.5423 10.1584 11.5606 10.0064 11.5606H9.99151C8.96527 11.5606 8.13333 10.7286 8.13333 9.70237C8.13333 9.5461 8.15262 9.39434 8.18895 9.24933L5.91885 6.97923C5.03505 7.69015 4.34057 8.62704 3.92328 9.70247C4.86803 12.1373 7.23361 13.8619 10.0002 13.8619C10.8326 13.8619 11.6287 13.7058 12.3608 13.4212ZM16.0771 9.70249C15.7843 10.4569 15.3552 11.1432 14.8199 11.7311L15.8813 12.7925C16.6329 11.9813 17.2187 11.0143 17.5849 9.94561C17.6389 9.78803 17.6389 9.61696 17.5849 9.45938C16.5055 6.30925 13.5184 4.04303 10.0002 4.04303C9.13525 4.04303 8.30244 4.17999 7.52218 4.43338L8.75139 5.66259C9.1556 5.58413 9.57311 5.54303 10.0002 5.54303C12.7667 5.54303 15.1323 7.26768 16.0771 9.70249Z" />
                        </svg>
                        }
                    </span>
                </div>
            </div>

            <!-- Terms & Conditions -->
            <div>
                <div class="flex items-center gap-3">
                    <app-checkbox className="w-5 h-5" [checked]="!!form.get('terms')?.value"
                        [error]="!!fieldError('terms')" (checkedChange)="onTermsChange($event)" />
                    <p class="inline-block font-normal text-gray-500 dark:text-gray-400">
                        By creating an account means you agree to the
                        <a routerLink="/legal/terms" target="_blank" rel="noopener"
                            class="text-brand-500 hover:underline dark:text-white/90">Terms and Conditions,</a>
                        and our
                        <a routerLink="/legal/privacy-policy" target="_blank" rel="noopener"
                            class="text-brand-500 hover:underline dark:text-white">Privacy Policy</a>
                    </p>
                </div>
                <!-- Terms error -->
                @if (fieldError('terms')) {
                <p class="mt-1.5 text-xs text-error-500">{{ fieldError('terms') }}</p>
                }
            </div>

            <app-button className="w-full" size="sm" (btnClick)="onSignUp()">
                Sign Up
            </app-button>

        </form>

        <div class="relative py-3 sm:py-5">
            <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-200 dark:border-gray-800"></div>
            </div>
            <div class="relative flex justify-center text-sm">
                <span class="p-2 text-gray-400 bg-white dark:bg-gray-900 sm:px-5 sm:py-2">Or</span>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-5">
            <!--
              Note: Google/Facebook sign-in for merchant registration is not wired up.
              The backend's social login always creates a regular USER account, and
              merchant accounts need Role.MERCHANT_PENDING + approval, so hooking
              these buttons up here would silently create the wrong account type.
              Leaving them as visual placeholders until a merchant-specific social
              signup endpoint exists.
            -->
            <button
                class="inline-flex items-center justify-center gap-3 py-3 text-sm font-normal text-gray-700 transition-colors bg-gray-100 rounded-lg px-7 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.7511 10.1944C18.7511 9.47495 18.6915 8.94995 18.5626 8.40552H10.1797V11.6527H15.1003C15.0011 12.4597 14.4654 13.675 13.2749 14.4916L13.2582 14.6003L15.9087 16.6126L16.0924 16.6305C17.7788 15.1041 18.7511 12.8583 18.7511 10.1944Z"
                        fill="#4285F4" />
                    <path
                        d="M10.1788 18.75C12.5895 18.75 14.6133 17.9722 16.0915 16.6305L13.274 14.4916C12.5201 15.0068 11.5081 15.3666 10.1788 15.3666C7.81773 15.3666 5.81379 13.8402 5.09944 11.7305L4.99473 11.7392L2.23868 13.8295L2.20264 13.9277C3.67087 16.786 6.68674 18.75 10.1788 18.75Z"
                        fill="#34A853" />
                    <path
                        d="M5.10014 11.7305C4.91165 11.186 4.80257 10.6027 4.80257 9.99992C4.80257 9.3971 4.91165 8.81379 5.09022 8.26935L5.08523 8.1534L2.29464 6.02954L2.20333 6.0721C1.5982 7.25823 1.25098 8.5902 1.25098 9.99992C1.25098 11.4096 1.5982 12.7415 2.20333 13.9277L5.10014 11.7305Z"
                        fill="#FBBC05" />
                    <path
                        d="M10.1789 4.63331C11.8554 4.63331 12.9864 5.34303 13.6312 5.93612L16.1511 3.525C14.6035 2.11528 12.5895 1.25 10.1789 1.25C6.68676 1.25 3.67088 3.21387 2.20264 6.07218L5.08953 8.26943C5.81381 6.15972 7.81776 4.63331 10.1789 4.63331Z"
                        fill="#EB4335" />
                </svg>
                Sign in with Google
            </button>
            <button
                class="inline-flex items-center justify-center gap-3 py-3 text-sm font-normal text-gray-700 transition-colors bg-gray-100 rounded-lg px-7 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20 10.0603C20 4.50529 15.5228 0 10 0C4.47715 0 0 4.50529 0 10.0603C0 15.0833 3.65686 19.2452 8.4375 19.9975V12.9253H5.89844V10.0603H8.4375V7.8459C8.4375 5.32357 9.93042 3.92926 12.2146 3.92926C13.3087 3.92926 14.4531 4.12591 14.4531 4.12591V6.60261H13.1922C11.9499 6.60261 11.5625 7.37733 11.5625 8.17197V10.0603H14.3359L13.8926 12.9253H11.5625V19.9975C16.3431 19.2452 20 15.0833 20 10.0603Z"
                        fill="#1877F2" />
                </svg>
                Sign in with Facebook
            </button>
        </div>

        <div>
            <p class="text-md font-normal text-center text-gray-700 dark:text-gray-400 sm:text-center">
                Already have an account?
                <a routerLink="/login" class="text-brand-500 hover:text-brand-600 dark:text-brand-400">
                    Sign in
                </a>
            </p>
        </div>
    </div>

    <app-confirmation-popup [isOpen]="showVerifyEmailPrompt" icon="user-add" title="Check Your Inbox"
        message="We've sent a verification link to your email. Please verify your account before signing in."
        confirmLabel="Login" cancelLabel="Go to Home" (confirmed)="goToLoginFromVerifyPrompt()"
        (cancelled)="goToHomeFromVerifyPrompt()">
    </app-confirmation-popup>
</div>